/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetInfrastructureGeoObjectsRequest,
  TGetInfrastructureGeoObjectsModel,
  IMappers,
  TGetInfrastructureGeoObjectsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IInfrastructureGeoObjectsResponse } from '../../entities/infrastructure/InfrastructureGeoObjectsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetInfrastructureGeoObjectsModel(
  parameters: IGetInfrastructureGeoObjectsRequest,
): TGetInfrastructureGeoObjectsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'infrastructure-caching',
    pathApi: '/v1/get-infrastructure-geo-objects/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetInfrastructureGeoObjectsRequest;
}

export async function fetchGetInfrastructureGeoObjects<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetInfrastructureGeoObjectsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetInfrastructureGeoObjectsModel(parameters),
    config,
  )) as FetchResponse<TGetInfrastructureGeoObjectsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IInfrastructureGeoObjectsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetInfrastructureGeoObjectsResponse>;
}
